export default __webpack_public_path__ + "locales/ro/ChangeUserTypeDialog.json?hash=46dc2d57464d76d51afa4895e73512e6";